<input
    #searchInput
    *ngLet="searchDebouncer$ | async"
    [formControl]="searchInputControl"
    [attr.disabled]="disabledInput ? '' : null"
    placeholder="{{ ('DATA.TABLE_FILTER.SEARCH' | translate) + '...' }}"
    class="search-input"
    (longPress)="onSearchPress()"
    (keydown.enter)="delayOnEnter(searchString)"
    [style.color]="error ? 'red' : 'black'"
    (click)="inputClick()"
    [class.hide-global-search]="hideGlobalSearchLink || !isRuLocale"
  />

  <div class="buttons-wrapper" *ngLet="langChange$ | async">
    <button class="btn-empty search-btn js-clear" (click)="onClear()" *ngIf="searchString">
      <svg [icon]="icons.Close" class="svg18 clear" />
    </button>

    <button class="btn-empty search-btn" (click)="delayOnSearch(searchString)" tabindex="-1">
      <svg [icon]="icons.Search" class="svg24 inactive-color search-icon" />
    </button>

    <button class="btn-empty tune-btn" (click)="goGlobalSearch()" *ngIf="!hideGlobalSearchLink && isRuLocale">
      <svg [icon]="icons.Tune" class="svg24 inactive-color tune-icon" />
    </button>
  </div>
